import SelectorEmpresas from '../SelectorEmpresas';
import SelectorRoles from '../SelectorRoles';

export const usuariosSchema = {
  fields: [
    {
      name: 'idsucutien',
      type: 'custom',
      component: SelectorEmpresas,
      label: 'Empresa',
      required: true,
      gridSpan: 'full'
    },
    {
      name: 'idrol',
      type: 'custom',
      component: SelectorRoles,
      label: 'Rol asignado',
      required: true,
      gridSpan: 'auto'
    },
    {
      name: 'nombre',
      type: 'text',
      label: 'Nombre(s)',
      required: true,
      placeholder: 'ej: Juan Carlos',
      gridSpan: 'auto',
      format: 'uppercase'
    },
    {
      name: 'login',
      type: 'text',
      label: 'Login de Usuario',
      required: true,
      placeholder: 'ej: JPEREZ2024',
      gridSpan: 'auto'
    },
    {
      name: 'password',
      type: 'password',
      label: 'Contraseña',
      required: true,
      placeholder: 'Contraseña segura',
      gridSpan: 'auto'
    },
    {
      name: 'email',
      type: 'email',
      label: 'Correo Electrónico',
      required: false,
      placeholder: 'ej: usuario@empresa.com',
      gridSpan: 'auto'
    },
    {
      name: 'activo',
      type: 'checkbox',
      label: 'Usuario activo',
      required: false,
      gridSpan: 'full'
    }
  ]
};

export const getUsuariosSchema = (isEditing = false) => {
  // No usar JSON.parse/stringify que rompe componentes React
  const schema = {
    fields: usuariosSchema.fields.map(field => {
      if (field.name === 'password' && isEditing) {
        return {
          ...field,
          required: false,
          placeholder: 'Dejar vacío para no cambiar'
        };
      }
      return field; // Mantener referencia original del componente
    })
  };
  
  return schema;
};